import { UserInfo } from '@shared/models/auth.model';
import { environment } from '@env/environment';

export function isZefAdmin(user: UserInfo): boolean {
  return !!user?.email?.endsWith('@zef.fi');
}

export function isZefSuperAdmin(user: UserInfo, groups: string[]): boolean {
  return isZefAdmin(user) && (groups?.includes('Console admins') || !environment.production);
}
